
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5KFAG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $24dy7 = parcelRequire("24dy7");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");

const $c7993e7601931a65$var$errorMessageWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'space.050'
});
const $c7993e7601931a65$var$errorMessageTextStyles = (0, $buxP3.xcss)({
    font: 'font.body.small',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
    color: 'color.text.accent.red'
});
const $c7993e7601931a65$export$1834f1a788ceaae3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "",
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $c7993e7601931a65$var$errorMessageWrapperStyles
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            xcss: $c7993e7601931a65$var$errorMessageTextStyles
        }, children));
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $c7993e7601931a65$var$errorMessageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-accent-red, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: $c7993e7601931a65$var$errorMessageTextStyles
    }, children));
module.exports["FormFieldErrorMessage"] = $c7993e7601931a65$export$1834f1a788ceaae3;

});

parcelRegister("9vJye", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $8b08841cb4906d94$export$c17cf6b332a82dbc = (0, $cozmU.createContext)(false);
const $8b08841cb4906d94$export$84e4f1713c208255 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($8b08841cb4906d94$export$c17cf6b332a82dbc);
} : ()=>(0, $cozmU.useContext)($8b08841cb4906d94$export$c17cf6b332a82dbc);
module.exports["IsDisabledContext"] = $8b08841cb4906d94$export$c17cf6b332a82dbc;
module.exports["useIsDisabledContext"] = $8b08841cb4906d94$export$84e4f1713c208255;

});

parcelRegister("3vLBh", function(module, exports) {
const $0a257e99456c2a58$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $0a257e99456c2a58$export$c23d8af8b1b8f2d7 = async (queryWord, pageNumber, submitError, shouldUseFullSizeImage)=>{
    try {
        const response = await fetch(`/wiki/rest/internals/1.0/unsplash/search?query=${queryWord}&pageNumber=${pageNumber}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Received status ${response.status}`);
        const responseData = await response.json();
        return responseData.results?.map((result)=>({
                id: result.id,
                altDescription: result.alt_description,
                smallSizeImageUrl: result.urls.thumb,
                fullSizeImageUrl: shouldUseFullSizeImage ? result.urls.full : result.urls.regular,
                artistName: result.user.name,
                artistUrl: result.user.links.html + $0a257e99456c2a58$export$535fddacdd1506a3,
                downloadLink: result.links.download_location
            }));
    } catch (error) {
        const err = error instanceof Error ? error : new Error('An unknown error occurred');
        submitError?.(err);
        throw err;
    }
};
module.exports["getUnsplashPhotos"] = $0a257e99456c2a58$export$c23d8af8b1b8f2d7;

});

parcelRegister("e70Gu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $dUI0h = parcelRequire("dUI0h");


var $dTHYM = parcelRequire("dTHYM");


var $f6cdQ = parcelRequire("f6cdQ");


var $a1ZzW = parcelRequire("a1ZzW");


var $i1t43 = parcelRequire("i1t43");


var $etoPX = parcelRequire("etoPX");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $cFVPs = parcelRequire("cFVPs");


var $gH7sg = parcelRequire("gH7sg");

const $f92e22574e782f04$var$i18n = (0, $kSwu1.defineMessages)({
    createImageLabel: {
        id: "ai-image-generation.rovo-header-image-generator.create-image-label",
        defaultMessage: "Create an image with Rovo"
    },
    getCreativePlaceholder: {
        id: "ai-image-generation.rovo-header-image-generator.get-creative-placeholder",
        defaultMessage: "Describe an image to create"
    },
    rovoIconAlt: {
        id: "ai-image-generation.rovo-header-image-generator.rovo-icon-alt",
        defaultMessage: "Rovo icon"
    },
    submitButtonLabel: {
        id: "ai-image-generation.rovo-header-image-generator.submit-button-label",
        defaultMessage: "Generate AI header image"
    },
    pickStyleLabel: {
        id: "ai-image-generation.rovo-header-image-generator.pick-style-label",
        defaultMessage: "Pick a style"
    },
    styleLabel: {
        id: "ai-image-generation.rovo-header-image-generator.style-label",
        defaultMessage: "Style"
    },
    stylePhotorealistic: {
        id: "ai-image-generation.rovo-header-image-generator.style-photorealistic",
        defaultMessage: "Photorealistic"
    },
    stylePhotoAuto: {
        id: "ai-image-generation.rovo-header-image-generator.style-photo-auto",
        defaultMessage: "Photo (Auto)"
    },
    styleAbstract: {
        id: "ai-image-generation.rovo-header-image-generator.style-abstract",
        defaultMessage: "Abstract"
    },
    styleWatercolors: {
        id: "ai-image-generation.rovo-header-image-generator.style-watercolors",
        defaultMessage: "Watercolors"
    },
    styleGraphicDesign: {
        id: "ai-image-generation.rovo-header-image-generator.style-graphic-design",
        defaultMessage: "Graphic Design"
    },
    styleLandscape: {
        id: "ai-image-generation.rovo-header-image-generator.style-landscape",
        defaultMessage: "Landscape"
    },
    styleSketch: {
        id: "ai-image-generation.rovo-header-image-generator.style-sketch",
        defaultMessage: "Sketch"
    },
    styleThreeD: {
        id: "ai-image-generation.rovo-header-image-generator.style-3d",
        defaultMessage: "3D"
    },
    imageModelLabel: {
        id: "ai-image-generation.rovo-header-image-generator.image-model-label",
        defaultMessage: "Image Model"
    },
    imageModelAuto: {
        id: "ai-image-generation.rovo-header-image-generator.image-model-auto",
        defaultMessage: "Auto"
    },
    imageModelAutoDescription: {
        id: "ai-image-generation.rovo-header-image-generator.image-model-auto-description",
        defaultMessage: "balance of speed and quality"
    },
    imageModelFast: {
        id: "ai-image-generation.rovo-header-image-generator.image-model-fast",
        defaultMessage: "Fast"
    },
    imageModelFastDescription: {
        id: "ai-image-generation.rovo-header-image-generator.image-model-fast-description",
        defaultMessage: "quickest results"
    },
    imageModelHigh: {
        id: "ai-image-generation.rovo-header-image-generator.image-model-high",
        defaultMessage: "High"
    },
    imageModelHighDescription: {
        id: "ai-image-generation.rovo-header-image-generator.image-model-high-description",
        defaultMessage: "pro-quality image generation"
    },
    imageModelMax: {
        id: "ai-image-generation.rovo-header-image-generator.image-model-max",
        defaultMessage: "Max"
    },
    imageModelMaxDescription: {
        id: "ai-image-generation.rovo-header-image-generator.image-model-max-description",
        defaultMessage: "best detail at 2K resolution"
    },
    footerMessage: {
        id: "ai-image-generation.rovo-header-image-generator.footer-message",
        defaultMessage: "Uses AI. Verify results."
    }
});
const $f92e22574e782f04$var$styles = {
    divider: "_3SamIHgVvo _39xV02N91d _0jFU0VHZdu _0KLXruG6qS",
    rovoIcon: "_39xV02ey7F _0jFU0Vey7F _0adFHsFQfX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    rovoHeader: "_0rIjykgVvo",
    imagePromptContainer: "_0bjKvD8fU6 _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _2Y7lL48HPE _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _37wbyuDIqT _0KLXrulfZc _0xmtko2ADO _43nrzT8HPE",
    stack: "_39xV02N91d _0aFT5vbt8w",
    actionsRow: "_39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    actionsLeft: "_3iDTPbQ4SZ _0hPCNLDIqT",
    footer: "_1UtDYzKGUX _46hvQm2ADO _3iDTPbQ4SZ _37wbyuDIqT _43nrzTTUhv _0rIjykB0rP"
};
const $f92e22574e782f04$export$ea36b789677ce46b = ({ allowImageModelSelection: allowImageModelSelection = false, generateAIHeaderImage: generateAIHeaderImage, isAiHeaderImageLoading: isAiHeaderImageLoading, isDisabled: isDisabled, moreActionsButton: moreActionsButton, onSubmit: onSubmit, prefillText: prefillText, useRemixStyleOptions: useRemixStyleOptions = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [selectedTheme, setSelectedTheme] = (0, $cozmU.useState)(null);
    const [selectedImageGenerationModel, setSelectedImageGenerationModel] = (0, $cozmU.useState)((0, $gH7sg.IMAGE_GENERATION_MODELS).auto);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError } = (0, $cFVPs.useAIEventsInstrumentation)({
        product: 'confluence',
        subproduct: 'confluence',
        aiFeatureName: 'aiHeaderImageGeneration',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        source: 'rovoHeaderImageGenerator'
    });
    const legacyThemeOptions = [
        {
            label: formatMessage($f92e22574e782f04$var$i18n.stylePhotorealistic),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).photorealistic
        },
        {
            label: formatMessage($f92e22574e782f04$var$i18n.styleThreeD),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).threeD
        },
        {
            label: formatMessage($f92e22574e782f04$var$i18n.styleSketch),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).sketch
        },
        {
            label: formatMessage($f92e22574e782f04$var$i18n.styleWatercolors),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).watercolors
        },
        {
            label: formatMessage($f92e22574e782f04$var$i18n.styleAbstract),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).abstract
        },
        {
            label: formatMessage($f92e22574e782f04$var$i18n.styleGraphicDesign),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).graphic_design
        },
        {
            label: formatMessage($f92e22574e782f04$var$i18n.styleLandscape),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).landscape
        }
    ];
    const remixThemeOptions = [
        {
            label: formatMessage($f92e22574e782f04$var$i18n.stylePhotoAuto),
            value: 'none'
        },
        {
            label: formatMessage($f92e22574e782f04$var$i18n.styleThreeD),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).headerImagesThreeD
        },
        {
            label: formatMessage($f92e22574e782f04$var$i18n.styleSketch),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).headerImagesSketch
        },
        {
            label: formatMessage($f92e22574e782f04$var$i18n.styleWatercolors),
            value: (0, $gH7sg.IMAGE_GENERATION_THEMES).headerImagesWatercolors
        }
    ];
    const themeOptions = useRemixStyleOptions ? remixThemeOptions : legacyThemeOptions;
    const imageGenerationModelOptions = [
        {
            description: formatMessage($f92e22574e782f04$var$i18n.imageModelMaxDescription),
            label: formatMessage($f92e22574e782f04$var$i18n.imageModelMax),
            value: (0, $gH7sg.IMAGE_GENERATION_MODELS).max
        },
        {
            description: formatMessage($f92e22574e782f04$var$i18n.imageModelHighDescription),
            label: formatMessage($f92e22574e782f04$var$i18n.imageModelHigh),
            value: (0, $gH7sg.IMAGE_GENERATION_MODELS).high
        },
        {
            description: formatMessage($f92e22574e782f04$var$i18n.imageModelAutoDescription),
            label: formatMessage($f92e22574e782f04$var$i18n.imageModelAuto),
            value: (0, $gH7sg.IMAGE_GENERATION_MODELS).auto
        },
        {
            description: formatMessage($f92e22574e782f04$var$i18n.imageModelFastDescription),
            label: formatMessage($f92e22574e782f04$var$i18n.imageModelFast),
            value: (0, $gH7sg.IMAGE_GENERATION_MODELS).fast
        }
    ];
    const selectedImageGenerationModelOption = imageGenerationModelOptions.find((option)=>option.value === selectedImageGenerationModel) ?? imageGenerationModelOptions[0];
    const effectivePrefillText = prefillText?.trim() ? prefillText : undefined; // Atlaskit Form stores values by field name; `defaultValue` only applies on mount.
    // When `prefillText` changes, force overwrite the form state for `promptInput`.
    const setFieldValueRef = (0, $cozmU.useRef)(null);
    const lastAppliedPrefillTextRef = (0, $cozmU.useRef)(undefined);
    const isLoading = isAiHeaderImageLoading ?? false;
    const isDisabledState = isLoading || Boolean(isDisabled);
    const handleThemeChange = (0, $cozmU.useCallback)((newValue)=>{
        setSelectedTheme((currentTheme)=>currentTheme?.value === newValue?.value ? null : newValue);
    }, []);
    const imageGenerationModelPicker = allowImageModelSelection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: "image-generation-model-picker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "semibold"
    }, formatMessage($f92e22574e782f04$var$i18n.imageModelLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        inputId: "image-generation-model-picker",
        options: imageGenerationModelOptions,
        value: selectedImageGenerationModelOption,
        onChange: (newValue)=>setSelectedImageGenerationModel(newValue?.value ?? (0, $gH7sg.IMAGE_GENERATION_MODELS).auto),
        formatOptionLabel: (option, { context: context })=>context === 'menu' ? `${option.label} - ${option.description}` : option.label,
        isDisabled: isDisabledState
    }))) : null;
    const handleFormSubmit = async (data)=>{
        if (isDisabledState) return;
        const selectedThemeValue = selectedTheme?.value === 'none' ? undefined : selectedTheme?.value;
        const useRawPrompt = !selectedThemeValue; // Notify the caller that the (enabled, valid) submit happened so they
        // can fire their own analytics. The caller owns this callback.
        onSubmit?.({
            imageGenerationModel: allowImageModelSelection ? selectedImageGenerationModel : 'none',
            selectedTheme: selectedThemeValue ?? 'none'
        }); // Track that user initiated AI image generation
        trackAIInteractionInit({
            attributes: {
                promptLength: data.promptInput?.length || 0,
                useRawPrompt: useRawPrompt,
                selectedTheme: selectedThemeValue ?? 'none'
            }
        });
        try {
            // Generate the AI header image with acceptance flow for repositioning UI
            await generateAIHeaderImage({
                adfContent: data.promptInput,
                useRawPrompt: useRawPrompt,
                showAcceptanceFlow: true,
                ...allowImageModelSelection && {
                    imageGenerationModel: selectedImageGenerationModel
                },
                ...selectedThemeValue && {
                    theme: selectedThemeValue
                }
            }); // Track successful result view
            trackAIResultView({
                attributes: {
                    promptLength: data.promptInput?.length || 0,
                    useRawPrompt: useRawPrompt,
                    selectedTheme: selectedThemeValue ?? 'none'
                }
            });
        } catch (error) {
            // Track error if generation fails
            trackAIResultError({
                aiErrorMessage: error instanceof Error ? error.message : 'Unknown error',
                aiErrorCode: error?.code
            });
        }
    };
    (0, $cozmU.useEffect)(()=>{
        // Do not update the form state if the image generation is not enabled
        if (!generateAIHeaderImage) return;
        if (!effectivePrefillText) return;
        if (lastAppliedPrefillTextRef.current === effectivePrefillText) return;
        lastAppliedPrefillTextRef.current = effectivePrefillText;
        setFieldValueRef.current?.('promptInput', effectivePrefillText);
    }, [
        effectivePrefillText,
        generateAIHeaderImage
    ]);
    if (!generateAIHeaderImage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f92e22574e782f04$var$styles.divider
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleFormSubmit
    }, ({ formProps: formProps, setFieldValue: setFieldValue })=>{
        setFieldValueRef.current = setFieldValue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f92e22574e782f04$var$styles.rovoHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f92e22574e782f04$var$styles.rovoIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "xsmall",
            label: formatMessage($f92e22574e782f04$var$i18n.rovoIconAlt)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
            htmlFor: "get-creative-text-area"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "bold",
            id: "get-creative-label"
        }, formatMessage($f92e22574e782f04$var$i18n.createImageLabel))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
            htmlFor: "theme-picker"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "semibold"
        }, formatMessage($f92e22574e782f04$var$i18n.styleLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            inputId: "theme-picker",
            options: themeOptions,
            value: selectedTheme,
            onChange: handleThemeChange,
            placeholder: formatMessage($f92e22574e782f04$var$i18n.pickStyleLabel),
            isDisabled: isDisabledState
        }))), imageGenerationModelPicker), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f92e22574e782f04$var$styles.imagePromptContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f92e22574e782f04$var$styles.stack
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default // Remount when the prefill text changes to ensure it overwrites any existing user input.
        ), {
            key: effectivePrefillText ?? 'promptInput',
            isRequired: true,
            name: "promptInput",
            id: "get-creative-text-area",
            defaultValue: effectivePrefillText ?? ''
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                placeholder: formatMessage($f92e22574e782f04$var$i18n.getCreativePlaceholder),
                appearance: "none",
                ...fieldProps,
                isDisabled: isDisabledState
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f92e22574e782f04$var$styles.actionsRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f92e22574e782f04$var$styles.actionsLeft
        }, moreActionsButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "primary",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
            label: formatMessage($f92e22574e782f04$var$i18n.submitButtonLabel),
            shape: "circle",
            type: "submit",
            isLoading: isLoading,
            isDisabled: isDisabledState
        })))));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f92e22574e782f04$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        color: "currentColor",
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage($f92e22574e782f04$var$i18n.footerMessage))))));
};
module.exports["RovoHeaderImageGenerator"] = $f92e22574e782f04$export$ea36b789677ce46b;

});

parcelRegister("hgxhy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $9vJye = parcelRequire("9vJye");

const $ad25417c5fcbe734$var$panelSubheaderStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest'
});
const $ad25417c5fcbe734$var$panelSubheaderDisabledStyles = (0, $buxP3.xcss)({
    color: 'color.text.disabled',
    ':hover': {
        cursor: 'not-allowed'
    }
});
const $ad25417c5fcbe734$export$12228125ac99294 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, showUpdatedStyles: t1 } = t0;
    const showUpdatedStyles = t1 === undefined ? false : t1;
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const t2 = isDisabled && $ad25417c5fcbe734$var$panelSubheaderDisabledStyles;
    let t3;
    if ($[0] !== t2) {
        t3 = [
            $ad25417c5fcbe734$var$panelSubheaderStyles,
            t2
        ];
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const t4 = showUpdatedStyles ? "medium" : "small";
    const t5 = showUpdatedStyles ? "regular" : "bold";
    const t6 = showUpdatedStyles ? "color.text" : "inherit";
    let t7;
    if ($[2] !== children || $[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            size: t4,
            weight: t5,
            color: t6
        }, children);
        $[2] = children;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== t3 || $[8] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t3
        }, t7);
        $[7] = t3;
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : ({ children: children, showUpdatedStyles: showUpdatedStyles = false })=>{
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $ad25417c5fcbe734$var$panelSubheaderStyles,
            isDisabled && $ad25417c5fcbe734$var$panelSubheaderDisabledStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        size: showUpdatedStyles ? 'medium' : 'small',
        weight: showUpdatedStyles ? 'regular' : 'bold',
        color: showUpdatedStyles ? 'color.text' : 'inherit'
    }, children));
};
module.exports["PanelSubheader"] = $ad25417c5fcbe734$export$12228125ac99294;

});

parcelRegister("eI3GM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DzWa = parcelRequire("9DzWa");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

const $4759245776f89f82$var$helperMessageWrapperStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.100',
    display: 'flex',
    justifyContent: 'space-between'
});
const $4759245776f89f82$var$helperMessageDisabledStyles = (0, $buxP3.xcss)({
    color: 'color.text.disabled'
});
const $4759245776f89f82$export$f3270c9ea239a57e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { helperMessage: helperMessage, isDisabled: isDisabled } = t0;
    let t1;
    if ($[0] !== helperMessage || $[1] !== isDisabled) {
        t1 = helperMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $4759245776f89f82$var$helperMessageWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: isDisabled ? $4759245776f89f82$var$helperMessageDisabledStyles : undefined
        }, helperMessage))) : null;
        $[0] = helperMessage;
        $[1] = isDisabled;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ helperMessage: helperMessage, isDisabled: isDisabled })=>helperMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $4759245776f89f82$var$helperMessageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: isDisabled ? $4759245776f89f82$var$helperMessageDisabledStyles : undefined
    }, helperMessage))) : null;
module.exports["MediaContentHelperMessage"] = $4759245776f89f82$export$f3270c9ea239a57e;

});

parcelRegister("3qXic", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $d0CGr = parcelRequire("d0CGr");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $9vJye = parcelRequire("9vJye");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");

const $769c025707655c9e$var$baseStyles = (0, $buxP3.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'radius.small',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
});
const $769c025707655c9e$var$selectedStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
});
const $769c025707655c9e$var$canBeSelectedStyles = (0, $buxP3.xcss)({
    cursor: 'auto'
});
const $769c025707655c9e$export$58ac8acf6266d241 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { image: image, isSelected: isSelected, canBeSelected: canBeSelected, onClick: onClick, children: children } = t0;
    const t1 = `${image} ${isSelected ? "1" : "0"}`;
    const t2 = canBeSelected && $769c025707655c9e$var$canBeSelectedStyles;
    const t3 = isSelected && $769c025707655c9e$var$selectedStyles;
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = [
            $769c025707655c9e$var$baseStyles,
            t2,
            t3
        ];
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    const t5 = `url(${image})`;
    let t6;
    if ($[3] !== t5) {
        t6 = {
            backgroundImage: t5
        };
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== children || $[6] !== isSelected || $[7] !== onClick || $[8] !== t1 || $[9] !== t4 || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            key: t1,
            "aria-pressed": isSelected,
            xcss: t4,
            style: t6,
            onClick: onClick
        }, children);
        $[5] = children;
        $[6] = isSelected;
        $[7] = onClick;
        $[8] = t1;
        $[9] = t4;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ image: image, isSelected: isSelected, canBeSelected: canBeSelected, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        // rerender when isSelected is changed to fix the issue when the component was not updated
        key: `${image} ${isSelected ? '1' : '0'}`,
        "aria-pressed": isSelected,
        xcss: [
            $769c025707655c9e$var$baseStyles,
            canBeSelected && $769c025707655c9e$var$canBeSelectedStyles,
            isSelected && $769c025707655c9e$var$selectedStyles
        ],
        style: {
            backgroundImage: `url(${image})`
        },
        onClick: onClick
    }, children);
};











var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");










const $f44db1cb26740678$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noImageLabel: {
        id: "company-hub.company-hub-common.unsplash-search.default-image-picker.no-image",
        defaultMessage: "No image"
    }
});


const $a9d60f4277f97074$var$baseStyles = (0, $buxP3.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'radius.small',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative'
});
const $a9d60f4277f97074$var$selectedStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
});
const $a9d60f4277f97074$var$noImageStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
    position: 'relative'
});
const $a9d60f4277f97074$var$noImageLineStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    left: '50%',
    top: '5%',
    height: '90%',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    rotate: '45deg'
});
const $a9d60f4277f97074$export$8b9fdf0a6bb637af = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { onClick: onClick, isSelected: isSelected, children: children } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const t1 = isSelected && $a9d60f4277f97074$var$selectedStyles;
    let t2;
    if ($[0] !== t1) {
        t2 = [
            $a9d60f4277f97074$var$baseStyles,
            $a9d60f4277f97074$var$noImageStyles,
            t1
        ];
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== intl) {
        t3 = intl.formatMessage((0, $f44db1cb26740678$export$defe85febe8b728c).noImageLabel);
        $[2] = intl;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $a9d60f4277f97074$var$noImageLineStyles
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== children || $[6] !== onClick || $[7] !== t2 || $[8] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            xcss: t2,
            testId: "unsplash-no-image",
            "aria-label": t3,
            onClick: onClick
        }, t4, children);
        $[5] = children;
        $[6] = onClick;
        $[7] = t2;
        $[8] = t3;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ onClick: onClick, isSelected: isSelected, children: children })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        xcss: [
            $a9d60f4277f97074$var$baseStyles,
            $a9d60f4277f97074$var$noImageStyles,
            isSelected && $a9d60f4277f97074$var$selectedStyles
        ],
        testId: "unsplash-no-image",
        "aria-label": intl.formatMessage((0, $f44db1cb26740678$export$defe85febe8b728c).noImageLabel),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a9d60f4277f97074$var$noImageLineStyles
    }), children);
};
















const $e55e0b9f112ae3ca$var$baseStyles = (0, $buxP3.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'radius.small',
    border: 'none'
});
const $e55e0b9f112ae3ca$var$placeholderStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $e55e0b9f112ae3ca$export$e327f3d4c8672489 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $e55e0b9f112ae3ca$var$baseStyles,
                $e55e0b9f112ae3ca$var$placeholderStyles
            ],
            testId: "image-picker-placeholders"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $e55e0b9f112ae3ca$var$baseStyles,
            $e55e0b9f112ae3ca$var$placeholderStyles
        ],
        testId: "image-picker-placeholders"
    });
};
















const $61e72dffc9a445be$var$baseStyles = (0, $buxP3.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'radius.small',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
});
const $61e72dffc9a445be$var$selectedStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
});
const $61e72dffc9a445be$var$canBeSelectedStyles = (0, $buxP3.xcss)({
    cursor: 'auto'
});
const $61e72dffc9a445be$export$99fc49c7c3f55eda = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { image: image, description: description, isSelected: isSelected, canBeSelected: canBeSelected, onClick: onClick, children: children } = t0;
    const t1 = `${image} ${isSelected ? "1" : "0"}`;
    const t2 = canBeSelected && $61e72dffc9a445be$var$canBeSelectedStyles;
    const t3 = isSelected && $61e72dffc9a445be$var$selectedStyles;
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = [
            $61e72dffc9a445be$var$baseStyles,
            t2,
            t3
        ];
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    const t5 = `url(${image})`;
    let t6;
    if ($[3] !== t5) {
        t6 = {
            backgroundImage: t5
        };
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== children || $[6] !== description || $[7] !== isSelected || $[8] !== onClick || $[9] !== t1 || $[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            key: t1,
            "aria-pressed": isSelected,
            "aria-label": description,
            xcss: t4,
            style: t6,
            onClick: onClick
        }, children);
        $[5] = children;
        $[6] = description;
        $[7] = isSelected;
        $[8] = onClick;
        $[9] = t1;
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : ({ image: image, description: description, isSelected: isSelected, canBeSelected: canBeSelected, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        // rerender when isSelected is changed to fix the issue when the component was not updated
        key: `${image} ${isSelected ? '1' : '0'}`,
        "aria-pressed": isSelected,
        "aria-label": description,
        xcss: [
            $61e72dffc9a445be$var$baseStyles,
            canBeSelected && $61e72dffc9a445be$var$canBeSelectedStyles,
            isSelected && $61e72dffc9a445be$var$selectedStyles
        ],
        style: {
            backgroundImage: `url(${image})`
        },
        onClick: onClick
    }, children);
};

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $w6R6I = parcelRequire("w6R6I");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $iQxQk = parcelRequire("iQxQk");


var $hBYtq = parcelRequire("hBYtq");


var $cfM7x = parcelRequire("cfM7x");





const $a6fa6bd9651d95ee$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    uploadImageFailedDescription: {
        id: "company-hub.company-hub-common.shared-components.unsplash-search.upload.error.description",
        defaultMessage: "Refresh the page and try again"
    },
    uploadImageFailedTitle: {
        id: "company-hub.company-hub-common.shared-components.unsplash-search.upload.error.title",
        defaultMessage: "Image failed to load"
    }
});


const $115b399fdec01266$var$IMAGE_CONFIGURATION = {
    allowAnimated: true,
    mode: 'full-fit',
    upscale: false
};
const $115b399fdec01266$var$styles = {
    base: "_0bjKvDKxmn _30huDKYbGa _0jFU0VUF4f _39xV02OYQB _1mT5xdRAKS _3OqcjTiObl _1DJ2rV715P _2z4m57UZDI",
    selected: "_2OUyjt3Alt"
};
const $115b399fdec01266$export$94984c14ad3e5368 = ({ contentId: contentId, imageId: imageId, isSelected: isSelected, onClick: onClick, children: children, mediaConfigOverride: mediaConfigOverride })=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { useMediaConfig: useMediaConfig } = (0, $cfM7x.useProductDependencies)();
    const { authProvider: authProvider, collection: collection, fileId: fileId } = useMediaConfig?.({
        contentId: contentId,
        imageSrc: imageId
    }) || {};
    let resolvedAuthProvider = authProvider;
    let resolvedCollection = collection;
    if (mediaConfigOverride?.authProvider && mediaConfigOverride?.collection) {
        resolvedAuthProvider = mediaConfigOverride.authProvider;
        resolvedCollection = mediaConfigOverride.collection;
    }
    const identifier = (0, $cozmU.useMemo)(()=>({
            mediaItemType: 'file',
            id: fileId ?? '',
            collectionName: resolvedCollection
        }), [
        fileId,
        resolvedCollection
    ]);
    if (!resolvedAuthProvider || !resolvedCollection || !fileId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e55e0b9f112ae3ca$export$e327f3d4c8672489), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iQxQk.MediaImageWithErrorBoundary //force rerender image on id change until https://product-fabric.atlassian.net/browse/CXP-2899 is fixed
    ), {
        key: fileId,
        identifier: identifier,
        mediaClientConfig: {
            authProvider: resolvedAuthProvider
        },
        apiConfig: $115b399fdec01266$var$IMAGE_CONFIGURATION
    }, ({ data: data, loading: loading, error: error })=>{
        if (loading || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e55e0b9f112ae3ca$export$e327f3d4c8672489), null);
        if (error) {
            showFlag({
                id: 'upload-image-error',
                title: formatMessage((0, $a6fa6bd9651d95ee$export$defe85febe8b728c).uploadImageFailedTitle),
                description: formatMessage((0, $a6fa6bd9651d95ee$export$defe85febe8b728c).uploadImageFailedDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            });
            createAnalyticsEvent({
                type: 'error',
                data: {
                    actionSubject: 'image',
                    actionSubjectId: 'coverImageSelected',
                    source: 'coverImageSelectedComponent'
                }
            }).fire();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e55e0b9f112ae3ca$export$e327f3d4c8672489), null);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($115b399fdec01266$var$styles.base, isSelected && $115b399fdec01266$var$styles.selected),
            style: {
                backgroundImage: `url(${data.src})`
            },
            onClick: onClick,
            testId: "uploaded-image-thumbnail"
        }, children);
    });
};


var $b8861d8063ef3fc3$export$bc1779d8140a60be = /*#__PURE__*/ function(ThumbnailType) {
    ThumbnailType[ThumbnailType["UNSPLASH_DEFAULT_IMAGE"] = 0] = "UNSPLASH_DEFAULT_IMAGE";
    ThumbnailType[ThumbnailType["UNSPLASH_IMAGE"] = 1] = "UNSPLASH_IMAGE";
    ThumbnailType[ThumbnailType["CUSTOM_IMAGE"] = 2] = "CUSTOM_IMAGE";
    ThumbnailType[ThumbnailType["EXTERNAL_SITE_IMAGE"] = 3] = "EXTERNAL_SITE_IMAGE";
    ThumbnailType[ThumbnailType["NO_IMAGE"] = 4] = "NO_IMAGE";
    return ThumbnailType;
}({});




var $619Qo = parcelRequire("619Qo");

const $3cfb97ffa71e0329$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
const $3cfb97ffa71e0329$var$createCustomImageThumbnail = (imageId)=>({
        type: (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).CUSTOM_IMAGE,
        image: {
            imageId: imageId
        }
    });
const $3cfb97ffa71e0329$export$7f2b17edc08bf65b = (image)=>({
        type: (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).UNSPLASH_DEFAULT_IMAGE,
        image: image
    });
const $3cfb97ffa71e0329$var$createUnsplashImageThumbnail = (url, altText)=>({
        type: (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).UNSPLASH_IMAGE,
        image: {
            fullSizeImageUrl: url,
            altDescription: altText
        }
    });
const $3cfb97ffa71e0329$var$createExternalSiteImageThumbnail = (url)=>({
        type: (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).EXTERNAL_SITE_IMAGE,
        image: url
    });
const $3cfb97ffa71e0329$var$initialUnsplashResultsIncludes = ({ image: image, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed })=>{
    if (!initialUnsplashResults?.length) return false;
    const adjustedUnsplashResults = isNoImageAllowed ? initialUnsplashResults.slice(2) : initialUnsplashResults.slice(1);
    return adjustedUnsplashResults.map((result)=>result.fullSizeImageUrl).includes(image || '');
};
const $3cfb97ffa71e0329$var$getFirstImageWhenSelectedImageIsUnsplash = ({ selectedImageUrl: selectedImageUrl, firstImage: firstImage, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, previewUploadedImageId: previewUploadedImageId, initialUploadedImageId: initialUploadedImageId, imageAltText: imageAltText })=>{
    const isSelectedUnsplashInInitialResults = (image = selectedImageUrl)=>$3cfb97ffa71e0329$var$initialUnsplashResultsIncludes({
            image: image,
            initialUnsplashResults: initialUnsplashResults,
            isNoImageAllowed: isNoImageAllowed
        });
    // if selected unsplash image is not in initial results array, then it should always be in the
    // first thumbnail
    if (!isSelectedUnsplashInInitialResults()) return $3cfb97ffa71e0329$var$createUnsplashImageThumbnail(selectedImageUrl, imageAltText);
    // TODO: this code can be removed when UnsplashSearch is replaced by MediaPickerContent
    const currentFirstImageUnsplash = firstImage?.current?.image && typeof firstImage?.current?.image !== 'string' && 'fullSizeImageUrl' in firstImage.current.image && (0, $619Qo.isUnsplashImage)(firstImage.current.image.fullSizeImageUrl) && firstImage?.current?.image?.fullSizeImageUrl;
    if (currentFirstImageUnsplash && selectedImageUrl !== currentFirstImageUnsplash) {
        if (!isSelectedUnsplashInInitialResults(currentFirstImageUnsplash) && isSelectedUnsplashInInitialResults()) return $3cfb97ffa71e0329$var$createUnsplashImageThumbnail(currentFirstImageUnsplash, imageAltText);
        if (!isSelectedUnsplashInInitialResults()) return $3cfb97ffa71e0329$var$createUnsplashImageThumbnail(selectedImageUrl, imageAltText);
    }
    if (previewUploadedImageId && firstImage.current?.image === previewUploadedImageId) {
        if (isSelectedUnsplashInInitialResults()) return firstImage.current;
        if (!isSelectedUnsplashInInitialResults()) return $3cfb97ffa71e0329$var$createUnsplashImageThumbnail(selectedImageUrl, imageAltText);
    }
    if (firstImage?.current?.image && typeof firstImage.current.image !== 'string' && 'imageId' in firstImage.current.image && isSelectedUnsplashInInitialResults()) return firstImage.current;
    if (isSelectedUnsplashInInitialResults() && previewUploadedImageId && initialUploadedImageId) return $3cfb97ffa71e0329$var$createCustomImageThumbnail(previewUploadedImageId);
    if (isSelectedUnsplashInInitialResults() && previewUploadedImageId) return $3cfb97ffa71e0329$var$createCustomImageThumbnail(previewUploadedImageId);
    if (isSelectedUnsplashInInitialResults() && initialUnsplashResults?.length) return $3cfb97ffa71e0329$export$7f2b17edc08bf65b(initialUnsplashResults[0]);
    return $3cfb97ffa71e0329$export$7f2b17edc08bf65b();
};
const $3cfb97ffa71e0329$export$e3511fb9079c14da = ({ selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, firstImage: firstImage, previewUploadedImageId: previewUploadedImageId, initialUploadedImageId: initialUploadedImageId, imageAltText: imageAltText })=>{
    if (selectedImageUrl) {
        if ((0, $619Qo.isUnsplashImage)(selectedImageUrl)) return $3cfb97ffa71e0329$var$getFirstImageWhenSelectedImageIsUnsplash({
            selectedImageUrl: selectedImageUrl,
            firstImage: firstImage,
            initialUnsplashResults: initialUnsplashResults,
            isNoImageAllowed: isNoImageAllowed,
            previewUploadedImageId: previewUploadedImageId,
            initialUploadedImageId: initialUploadedImageId,
            imageAltText: imageAltText
        });
        else {
            if ($3cfb97ffa71e0329$var$externalSiteMatcher.test(selectedImageUrl)) return $3cfb97ffa71e0329$var$createExternalSiteImageThumbnail(selectedImageUrl);
            return $3cfb97ffa71e0329$var$createCustomImageThumbnail(selectedImageUrl);
        }
    }
    if (initialUploadedImageId) return $3cfb97ffa71e0329$var$createCustomImageThumbnail(initialUploadedImageId);
    if (initialUnsplashResults?.length) return $3cfb97ffa71e0329$export$7f2b17edc08bf65b(initialUnsplashResults[0]);
    return $3cfb97ffa71e0329$export$7f2b17edc08bf65b();
};


const $746ab927bb116314$var$styles = {
    imagesWrapper: "_3138422ADO _37wbyuI7V3 _0Of8r2Pgdg",
    checkboxWrapper: "_1mT5xdRAKS",
    selectedImageTick: "_1mT5xdWVPG _0Bm75GPgdg _4ApkO2Pgdg _3Ku51Iogpp _4diMdqmhAQ _1lBcDc715P _3ScelF715P _3dCYwDWVPG _1D2b5M1Y8M _35I30B1Y8M"
};
const $746ab927bb116314$var$isUnsplashDefaultImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).UNSPLASH_DEFAULT_IMAGE;
};
const $746ab927bb116314$var$isUnsplashImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).UNSPLASH_IMAGE;
};
const $746ab927bb116314$var$isCustomImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).CUSTOM_IMAGE;
};
const $746ab927bb116314$var$isExternalSiteImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).EXTERNAL_SITE_IMAGE;
};
const $746ab927bb116314$var$isNoImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).NO_IMAGE;
};
const $746ab927bb116314$var$createNoImageThumbnail = ()=>({
        type: (0, $b8861d8063ef3fc3$export$bc1779d8140a60be).NO_IMAGE,
        image: undefined
    });
const $746ab927bb116314$export$71256286fd384466 = ()=>{
    return Array(5).fill(null).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e55e0b9f112ae3ca$export$e327f3d4c8672489), {
            key: index
        }));
};
const $746ab927bb116314$export$62a2f85610ce8d51 = ({ contentId: contentId, imageAltText: imageAltText, selectedImageUrl: selectedImageUrl, handleImageSelection: handleImageSelection, initialUnsplashResults: initialUnsplashResults, analyticsSource: analyticsSource, isUploadingImage: isUploadingImage, isNoImageAllowed: isNoImageAllowed, initialUploadedImageId: initialUploadedImageId, previewUploadedImageId: previewUploadedImageId, mediaConfigOverride: mediaConfigOverride })=>{
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onImageClick = (0, $cozmU.useCallback)(({ fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription, downloadLink: downloadLink })=>{
        if (!isUploadingImage) {
            handleImageSelection({
                fullSizeImageUrl: fullSizeImageUrl,
                altDescription: altDescription,
                downloadLink: downloadLink
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'image',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'unsplashDefault'
                    }
                }
            }).fire();
        }
    }, [
        analyticsSource,
        createAnalyticsEvent,
        handleImageSelection,
        isUploadingImage
    ]);
    const renderCheckboxIcon = (0, $cozmU.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $746ab927bb116314$var$styles.selectedImageTick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $746ab927bb116314$var$styles.checkboxWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0CGr))), {
            label: "checkmark",
            color: "var(--ds-icon-brand, #1868DB)"
        })));
    }, []);
    const renderGenericUnsplashImage = (0, $cozmU.useCallback)(({ smallSizeImageUrl: smallSizeImageUrl, fullSizeImageUrl: fullSizeImageUrl_0, description: description, isSelected: isSelected, index: index, downloadLink: downloadLink_0 })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61e72dffc9a445be$export$99fc49c7c3f55eda), {
            key: `thumbnail-${index}`,
            image: smallSizeImageUrl,
            description: description,
            isSelected: isSelected,
            canBeSelected: isUploadingImage,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: fullSizeImageUrl_0,
                    altDescription: description,
                    downloadLink: downloadLink_0
                })
        }, isSelected && renderCheckboxIcon());
    }, [
        isUploadingImage,
        onImageClick,
        renderCheckboxIcon
    ]);
    const renderUnsplashDefaultImage = (0, $cozmU.useCallback)((image, index_0)=>{
        const { fullSizeImageUrl: fullSizeImageUrl_1, altDescription: altDescription_0, downloadLink: downloadLink_1, smallSizeImageUrl: smallSizeImageUrl_0 } = image;
        const isSelected_0 = fullSizeImageUrl_1 === selectedImageUrl;
        return renderGenericUnsplashImage({
            smallSizeImageUrl: smallSizeImageUrl_0 ?? fullSizeImageUrl_1,
            fullSizeImageUrl: fullSizeImageUrl_1,
            description: altDescription_0,
            isSelected: isSelected_0,
            index: index_0,
            downloadLink: downloadLink_1
        });
    }, [
        selectedImageUrl,
        renderGenericUnsplashImage
    ]);
    const renderUnsplashImage = (0, $cozmU.useCallback)((image_0, index_1)=>{
        const { fullSizeImageUrl: fullSizeImageUrl_2, altDescription: altDescription_1 } = image_0;
        const isSelected_1 = fullSizeImageUrl_2 === selectedImageUrl;
        return renderGenericUnsplashImage({
            smallSizeImageUrl: fullSizeImageUrl_2,
            fullSizeImageUrl: fullSizeImageUrl_2,
            description: altDescription_1 ?? '',
            isSelected: isSelected_1,
            index: index_1,
            downloadLink: undefined
        });
    }, [
        selectedImageUrl,
        renderGenericUnsplashImage
    ]);
    const renderExternalSiteImage = (0, $cozmU.useCallback)((image_1, index_2)=>{
        const isSelectedImage = image_1 === selectedImageUrl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $769c025707655c9e$export$58ac8acf6266d241), {
            key: `thumbnail-${index_2}`,
            image: image_1,
            isSelected: isSelectedImage,
            canBeSelected: isUploadingImage,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: image_1,
                    altDescription: ''
                })
        }, isSelectedImage && renderCheckboxIcon());
    }, [
        selectedImageUrl,
        isUploadingImage,
        renderCheckboxIcon,
        onImageClick
    ]);
    const renderUploadedImage = (0, $cozmU.useCallback)((image_2, index_3)=>{
        const { imageId: imageId } = image_2;
        const isSelectedImage_0 = imageId === selectedImageUrl && index_3 === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $115b399fdec01266$export$94984c14ad3e5368), {
            key: `thumbnail-${index_3}`,
            contentId: contentId,
            imageId: imageId,
            isSelected: isSelectedImage_0,
            mediaConfigOverride: mediaConfigOverride,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: imageId,
                    altDescription: ''
                })
        }, isSelectedImage_0 && renderCheckboxIcon());
    }, [
        selectedImageUrl,
        contentId,
        onImageClick,
        renderCheckboxIcon,
        mediaConfigOverride
    ]);
    const renderNoImageThumbnail = (0, $cozmU.useCallback)((index_4)=>{
        const isSelected_2 = selectedImageUrl === '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9d60f4277f97074$export$8b9fdf0a6bb637af), {
            key: index_4,
            isSelected: isSelected_2,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: '',
                    altDescription: ''
                })
        }, isSelected_2 && renderCheckboxIcon());
    }, [
        selectedImageUrl,
        onImageClick,
        renderCheckboxIcon
    ]);
    const firstImage = (0, $cozmU.useRef)();
    firstImage.current = (0, $3cfb97ffa71e0329$export$e3511fb9079c14da)({
        selectedImageUrl: selectedImageUrl,
        initialUnsplashResults: initialUnsplashResults,
        isNoImageAllowed: isNoImageAllowed,
        firstImage: firstImage,
        previewUploadedImageId: previewUploadedImageId,
        initialUploadedImageId: initialUploadedImageId,
        imageAltText: imageAltText
    });
    const secondImage = isNoImageAllowed ? $746ab927bb116314$var$createNoImageThumbnail() : (0, $3cfb97ffa71e0329$export$7f2b17edc08bf65b)(initialUnsplashResults?.[1]);
    const imagesToDisplay = [
        firstImage.current,
        secondImage,
        (0, $3cfb97ffa71e0329$export$7f2b17edc08bf65b)(initialUnsplashResults?.[2]),
        (0, $3cfb97ffa71e0329$export$7f2b17edc08bf65b)(initialUnsplashResults?.[3]),
        (0, $3cfb97ffa71e0329$export$7f2b17edc08bf65b)(initialUnsplashResults?.[4])
    ];
    const renderThumbnails = (0, $cozmU.useCallback)((thumbnail, index_5)=>{
        // Ordering matters for first image rendering logic
        if ($746ab927bb116314$var$isNoImageThumbnail(thumbnail)) return renderNoImageThumbnail(index_5);
        if (!thumbnail.image) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e55e0b9f112ae3ca$export$e327f3d4c8672489), {
            key: index_5
        });
        if ($746ab927bb116314$var$isUnsplashDefaultImageThumbnail(thumbnail)) return renderUnsplashDefaultImage(thumbnail.image, index_5);
        if ($746ab927bb116314$var$isUnsplashImageThumbnail(thumbnail)) return renderUnsplashImage(thumbnail.image, index_5);
        if ($746ab927bb116314$var$isExternalSiteImageThumbnail(thumbnail)) return renderExternalSiteImage(thumbnail.image, index_5);
        if ($746ab927bb116314$var$isCustomImageThumbnail(thumbnail)) return renderUploadedImage(thumbnail.image, index_5);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e55e0b9f112ae3ca$export$e327f3d4c8672489), {
            key: index_5
        });
    }, [
        renderNoImageThumbnail,
        renderUnsplashDefaultImage,
        renderUnsplashImage,
        renderUploadedImage,
        renderExternalSiteImage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $746ab927bb116314$var$styles.imagesWrapper,
        testId: "default-image-picker"
    }, isDisabled ? $746ab927bb116314$export$71256286fd384466() : imagesToDisplay.map(renderThumbnails));
};
module.exports["DefaultImagePicker"] = $746ab927bb116314$export$62a2f85610ce8d51;

});

parcelRegister("k8b3h", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $hAgam = parcelRequire("hAgam");


var $4n1IT = parcelRequire("4n1IT");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $4yg9g = parcelRequire("4yg9g");


var $9vJye = parcelRequire("9vJye");


var $cfM7x = parcelRequire("cfM7x");


var $iaYF8 = parcelRequire("iaYF8");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $hekY6 = parcelRequire("hekY6");








var $vIR70 = parcelRequire("vIR70");


var $cJ0FD = parcelRequire("cJ0FD");


var $iDrrr = parcelRequire("iDrrr");




var $d1308cceb6011831$exports = {};
$d1308cceb6011831$exports = new URL("NoResults.9d75157a.svg", import.meta.url).toString();






var $3vLBh = parcelRequire("3vLBh");




const $a25ab1c1bee056dc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unsplashNoResultsText: {
        id: "company-hub.company-hub-common.unsplash.search.no.results.text",
        defaultMessage: "Nothing matches your search"
    },
    unsplashLoadMoreAriaLabel: {
        id: "company-hub.company-hub-common.unsplash.search.load-more.aria-label",
        defaultMessage: "Load more header images"
    },
    unsplashNoMoreResultsToLoadText: {
        id: "company-hub.company-hub-common.unsplash.search.no.more.results.to.load.text",
        defaultMessage: "No more matches try another search"
    },
    unsplashLegal: {
        id: "company-hub.company-hub-common.unsplash.legal",
        defaultMessage: "By using images from Unsplash, you agree to their {unsplashLicenseLink} and {unsplashTermsOfServiceLink}."
    },
    unsplashLicenseLink: {
        id: "company-hub.company-hub-common.unsplash.license",
        defaultMessage: "license"
    },
    unsplashTermsOfServiceLink: {
        id: "company-hub.company-hub-common.unsplash.terms.of.service.",
        defaultMessage: "Terms of Service"
    },
    unsplashResultsCount: {
        id: "company-hub.company-hub-common.unsplash.search.results.count",
        defaultMessage: "{count} results found"
    },
    unsplashNoResultsAnnouncement: {
        id: "company-hub.company-hub-common.unsplash.search.no.results.announcement",
        defaultMessage: "No results found"
    },
    unsplashSearchResultsLabel: {
        id: "company-hub.company-hub-common.unsplash.search.results.label",
        defaultMessage: "Search results"
    }
});


const $f1d03c9b77a76dda$var$UNSPLASH_LICENSE_LINK = 'https://unsplash.com/license';
const $f1d03c9b77a76dda$var$UNSPLASH_TERMS_OF_SERVICE_LINK = 'https://unsplash.com/terms'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d03c9b77a76dda$var$SearchContentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1EqgXlI4rv",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1EqgXlI4rv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d03c9b77a76dda$var$SearchResultsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LALTLW _2WAcuGLTLW _2mHwu82ADO _3iDTPbgBM8 _0NUa3r2MnX _2iEGP2xqa9 _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LALTLW _2WAcuGLTLW _2mHwu82ADO _3iDTPbgBM8 _0NUa3r2MnX _2iEGP2xqa9 _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d03c9b77a76dda$var$UnsplashWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbkfkE _1mT5xdRAKS _39xV02YmZn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbkfkE _1mT5xdRAKS _39xV02YmZn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d03c9b77a76dda$var$ImageResultsList = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbcK7c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbcK7c",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$artistInfoSelector = 'items.ArtistInfo'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d03c9b77a76dda$var$ArtistInfo = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _0KLXruVzWZ _1v9SsVzXzM _3XDz3BzXzM _1mT5xdWVPG _0Bm75GdnbC _39xV02N91d _1YKVNs7dHp _0fKRyPnQyn _0Hc5gqYvD1",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _0KLXruVzWZ _1v9SsVzXzM _3XDz3BzXzM _1mT5xdWVPG _0Bm75GdnbC _39xV02N91d _1YKVNs7dHp _0fKRyPnQyn _0Hc5gqYvD1",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$ArtistLink = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_00uqCYxTF4 _3xtjKNOiJt _0H9qDFp3yX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_00uqCYxTF4 _3xtjKNOiJt _0H9qDFp3yX",
            __cmplp.className
        ])
    });
});
$f1d03c9b77a76dda$var$ArtistInfo.defaultProps = {
    'data-styled-selector': $f1d03c9b77a76dda$var$artistInfoSelector
};
const $f1d03c9b77a76dda$var$ModernArtistInfo = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ "data-styled-selector": t1, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = t1;
    } else {
        props = $[1];
        t1 = $[2];
    }
    const dataStyledSelector = t1 === undefined ? $f1d03c9b77a76dda$var$artistInfoSelector : t1;
    let t2;
    if ($[3] !== dataStyledSelector || $[4] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ArtistInfo, {
            ...props,
            "data-styled-selector": dataStyledSelector
        });
        $[3] = dataStyledSelector;
        $[4] = props;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ 'data-styled-selector': dataStyledSelector = $f1d03c9b77a76dda$var$artistInfoSelector, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ArtistInfo, {
        ...props,
        "data-styled-selector": dataStyledSelector
    });
const $f1d03c9b77a76dda$var$ArtistInfoWithDefaultPropsGate = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("nike_r19_default_props") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ModernArtistInfo, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ArtistInfo, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>(0, $iDrrr.fg)('nike_r19_default_props') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ModernArtistInfo, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ArtistInfo, props); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d03c9b77a76dda$var$ArtistNameWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2XsHFM1Y8M _1UtDYze5R3 _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2XsHFM1Y8M _1UtDYze5R3 _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$baseImageStyles = {
    width: '100%',
    height: '77.93px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d03c9b77a76dda$var$UnsplashImage = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDzXzM _39xV02N91d _0jFU0VXxqS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _39xV02N91d _0jFU0VXxqS",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d03c9b77a76dda$var$UnsplashImageWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_30huDKYbGa _2uo31fYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0wOv4Q7zJH _0jFU0VXxqS _2xIroY9SWg _1jpxTzYvD1",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _2uo31fYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0wOv4Q7zJH _0jFU0VXxqS _2xIroY9SWg _1jpxTzYvD1",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$UnsplashLegalTerms = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _0Of8r22ADO _1ZnuxbdnbC _1wydGW2ADO _2Zuz6QdnbC _0KLXrumhAQ _1v9SsVzXzM _3XDz3BzXzM _1UtDYzZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _0Of8r22ADO _1ZnuxbdnbC _1wydGW2ADO _2Zuz6QdnbC _0KLXrumhAQ _1v9SsVzXzM _3XDz3BzXzM _1UtDYzZpcK",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$LegalTextWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842Pgdg _0adFHs2ADO _1DCdHiPgdg _2XsHFM2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842Pgdg _0adFHs2ADO _1DCdHiPgdg _2XsHFM2ADO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d03c9b77a76dda$var$UnderlinedLink = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYz1PzL",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYz1PzL",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$EndofResultsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _2EmVEzOOnw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _2EmVEzOOnw",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$UnsplashSearchErrorWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu85zaO _2j3gqAygBI _3iDTPbQ4SZ _0jFU0VgNBR _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu85zaO _2j3gqAygBI _3iDTPbQ4SZ _0jFU0VgNBR _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$SearchErrorText = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1UtDYzZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1UtDYzZpcK",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$ImagePlaceholder = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDzXzM _39xV02N91d _0jFU0VXxqS _0KLXruDMqu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _39xV02N91d _0jFU0VXxqS _0KLXruDMqu",
            __cmplp.className
        ])
    });
});
const $f1d03c9b77a76dda$var$UnsplashLicenseLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnderlinedLink, {
            target: "_blank",
            href: $f1d03c9b77a76dda$var$UNSPLASH_LICENSE_LINK
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashLicenseLink));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnderlinedLink, {
        target: "_blank",
        href: $f1d03c9b77a76dda$var$UNSPLASH_LICENSE_LINK
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashLicenseLink));
const $f1d03c9b77a76dda$var$UnsplashTermsOfServiceLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnderlinedLink, {
            target: "_blank",
            href: $f1d03c9b77a76dda$var$UNSPLASH_TERMS_OF_SERVICE_LINK
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashTermsOfServiceLink));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnderlinedLink, {
        target: "_blank",
        href: $f1d03c9b77a76dda$var$UNSPLASH_TERMS_OF_SERVICE_LINK
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashTermsOfServiceLink));
const $f1d03c9b77a76dda$export$dab0686b1ddf2c98 = ({ unSplashSearchResults: unSplashSearchResults, id: id, idPrefix: idPrefix, handleImageSelection: handleImageSelection, loadMoreText: loadMoreText, queryWord: queryWord, pageNumber: pageNumber, setUnsplashSearchResults: setUnsplashSearchResults, handleError: handleError, searchResultsRef: searchResultsRef, unsplashResultsCountFromLastAPICall: unsplashResultsCountFromLastAPICall, setUnsplashResultsCountFromLastAPICall: setUnsplashResultsCountFromLastAPICall, dropdownPopupComponentRef: dropdownPopupComponentRef, isPageTitleComponent: isPageTitleComponent, analyticsSource: analyticsSource })=>{
    const [showButtonSpinner, setShowButtonSpinner] = (0, $cozmU.useState)(false);
    const imageRef = (0, $cozmU.useRef)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onImageClick = ({ fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription, downloadLink: downloadLink })=>{
        handleImageSelection({
            fullSizeImageUrl: fullSizeImageUrl,
            altDescription: altDescription,
            downloadLink: downloadLink
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'selected',
                actionSubject: 'image',
                source: analyticsSource,
                attributes: {
                    imageSource: 'unsplashSearch'
                }
            }
        }).fire();
    };
    const onKeyDown = (e, result)=>{
        if (e.key === 'Enter' || e.key === ' ') onImageClick(result);
    };
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const onClickLoadMoreButton = ()=>{
        setShowButtonSpinner(true);
        pageNumber.current++;
        const defaultQueryWord = isPageTitleComponent ? (0, $iaYF8.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD) : (0, $iaYF8.DEFAULT_UNSPLASH_QUERY_WORD);
        const queryKeyword = queryWord.current || defaultQueryWord;
        (0, $3vLBh.getUnsplashPhotos)(queryKeyword, pageNumber.current, submitError, isPageTitleComponent).then((results)=>{
            setUnsplashResultsCountFromLastAPICall(results.length);
            setUnsplashSearchResults(unSplashSearchResults.concat(results));
            setShowButtonSpinner(false);
            imageRef.current?.focus();
        }).catch((error)=>{
            handleError(error);
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'loadMoreUnsplashImagesButtonClicked',
                source: analyticsSource
            }
        }).fire();
    };
    const UnsplashLegalText = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$LegalTextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashLegal,
            values: {
                unsplashLicenseLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnsplashLicenseLink, null),
                unsplashTermsOfServiceLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnsplashTermsOfServiceLink, null)
            }
        }));
    };
    const resultsCount = unSplashSearchResults?.filter(Boolean).length ?? 0;
    const hasSearchOptions = resultsCount > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$SearchContentContainer, {
        id: id,
        ref: dropdownPopupComponentRef,
        onClick: (e_0)=>e_0.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- live region must be visually hidden */ style: {
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0,0,0,0)',
            whiteSpace: 'nowrap',
            border: 0
        },
        /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, resultsCount > 0 ? formatMessage((0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashResultsCount, {
        count: resultsCount
    }) : formatMessage((0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashNoResultsAnnouncement)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$SearchResultsContainer, {
        ref: searchResultsRef,
        ...hasSearchOptions ? {
            role: 'listbox',
            'aria-label': formatMessage((0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashSearchResultsLabel)
        } : {}
    }, unSplashSearchResults?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ImageResultsList, null, unSplashSearchResults.map((result_0, index)=>result_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnsplashWrapper, {
            key: index,
            "data-testid": `${idPrefix}-unsplash-image-${result_0.id}`,
            onKeyDown: (e_1)=>onKeyDown(e_1, result_0)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnsplashImageWrapper // assign ref to image result only when it is the first of 30 new images loaded more.
        , {
            // This ref is necessary for placing focus on the image result away from load more button
            ref: index === unSplashSearchResults.length - 30 ? imageRef : null,
            onClick: ()=>onImageClick(result_0),
            role: "option",
            "aria-selected": false,
            id: `${idPrefix}-option-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnsplashImage, {
            src: result_0.smallSizeImageUrl,
            alt: result_0.altDescription
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ArtistInfoWithDefaultPropsGate, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ArtistLink, {
            href: result_0.artistUrl,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ArtistNameWrapper, null, result_0.artistName)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnsplashWrapper, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$ImagePlaceholder, {
            "data-testid": "unsplash-popup-image-placeholder"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$EndofResultsWrapper, null, unsplashResultsCountFromLastAPICall === 30 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vIR70.default), {
        onClick: onClickLoadMoreButton,
        spacing: "compact",
        isLoading: showButtonSpinner,
        "aria-label": formatMessage((0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashLoadMoreAriaLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), loadMoreText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$SearchErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashNoMoreResultsToLoadText)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnsplashSearchErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d1308cceb6011831$exports))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$SearchErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a25ab1c1bee056dc$export$defe85febe8b728c).unsplashNoResultsText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d03c9b77a76dda$var$UnsplashLegalTerms, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(UnsplashLegalText, null)));
};








const $6b20cf9bddcc6c7c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    refinedUnsplashSearchPlaceholderText: {
        id: "company-hub.company-hub-common.refined.unsplash.search.placeholder",
        defaultMessage: "Browse Unsplash"
    },
    unsplashLoadMoreText: {
        id: "company-hub.company-hub-common.unsplash.search.load.more.unsplash.photos",
        defaultMessage: "Load more"
    },
    unsplashSearchAriaLabel: {
        id: "company-hub.company-hub-common.unsplash.search.aria-label",
        defaultMessage: "Search header images"
    }
});


const $cf7a0cd5aef48e09$var$iconContainerStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.100'
});
const $cf7a0cd5aef48e09$export$a7e261e3ec8ef2a0 = ({ elementIdPrefix: elementIdPrefix, unsplashSearchFieldId: unsplashSearchFieldId, handleImageSelection: handleImageSelection, dropdownPopupComponentRef: dropdownPopupComponentRef, placement: placement = 'bottom', analyticsSource: analyticsSource, isPageTitleComponent: isPageTitleComponent = false, isUploadingImage: isUploadingImage = false, defaultUnsplashResults: defaultUnsplashResults, setDefaultUnsplashResults: setDefaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const [unsplashResultsCountFromLastAPICall, setUnsplashResultsCountFromLastAPICall] = (0, $cozmU.useState)(30);
    const hasSearchOptions = (unSplashSearchResults?.filter(Boolean).length ?? 0) > 0;
    const searchResultsRef = (0, $cozmU.useRef)(null);
    const pageNumber = (0, $cozmU.useRef)(1);
    const textfieldInputValue = (0, $cozmU.useRef)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const debouncedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((searchBar)=>{
        textfieldInputValue.current = searchBar?.value;
        const defaultQueryWord = isPageTitleComponent ? (0, $iaYF8.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD) : (0, $iaYF8.DEFAULT_UNSPLASH_QUERY_WORD);
        const queryKeyword = textfieldInputValue.current || defaultQueryWord;
        setUnsplashSearchResults(Array(30).fill(null));
        (0, $3vLBh.getUnsplashPhotos)(queryKeyword, pageNumber.current, submitError, isPageTitleComponent).then((result)=>{
            if (!defaultUnsplashResults || defaultUnsplashResults.length === 0) setDefaultUnsplashResults(result);
            setUnsplashResultsCountFromLastAPICall(result.length);
            setUnsplashSearchResults(result);
            setError(undefined);
        }).catch((error)=>{
            handleError(error);
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'typed',
                actionSubject: 'headerImageSearch',
                actionSubjectId: 'headerImageSearchTyped',
                source: analyticsSource
            }
        }).fire();
    }, 350);
    const handleSearchOnChange = (event)=>{
        pageNumber.current = 1;
        debouncedQuery(event.target);
        searchResultsRef.current?.scroll({
            top: 0,
            behavior: 'smooth'
        });
    };
    const handleChange = ()=>{
        setIsPopupOpen(true);
    };
    const handleKeyDown = (event_0)=>{
        if ([
            'Enter',
            ' ',
            'ArrowUp',
            'ArrowDown'
        ].includes(event_0.key)) {
            if (event_0.key === ' ' && !textfieldInputValue.current) event_0.preventDefault();
            handleChange();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        autoFocus: false,
        role: "dialog",
        onClose: ()=>setIsPopupOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1d03c9b77a76dda$export$dab0686b1ddf2c98), {
                id: `${elementIdPrefix}-unsplash-popup-content`,
                dropdownPopupComponentRef: dropdownPopupComponentRef,
                unSplashSearchResults: unSplashSearchResults,
                idPrefix: elementIdPrefix,
                handleImageSelection: handleImageSelection,
                loadMoreText: (0, $6b20cf9bddcc6c7c$export$defe85febe8b728c).unsplashLoadMoreText,
                queryWord: textfieldInputValue,
                pageNumber: pageNumber,
                setUnsplashSearchResults: setUnsplashSearchResults,
                handleError: handleError,
                searchResultsRef: searchResultsRef,
                unsplashResultsCountFromLastAPICall: unsplashResultsCountFromLastAPICall,
                setUnsplashResultsCountFromLastAPICall: setUnsplashResultsCountFromLastAPICall,
                isPageTitleComponent: isPageTitleComponent,
                analyticsSource: analyticsSource
            }),
        isOpen: isPopupOpen,
        placement: placement,
        testId: "unsplash-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ...triggerProps,
                role: "combobox",
                "aria-expanded": isPopupOpen,
                "aria-controls": `${elementIdPrefix}-unsplash-popup-content`,
                "aria-label": formatMessage((0, $6b20cf9bddcc6c7c$export$defe85febe8b728c).unsplashSearchAriaLabel),
                "aria-autocomplete": hasSearchOptions ? 'list' : undefined,
                "aria-haspopup": hasSearchOptions ? 'listbox' : undefined,
                id: unsplashSearchFieldId,
                testId: `${elementIdPrefix}-unsplash-search-bar`,
                onChange: handleSearchOnChange,
                onClick: handleChange,
                onInput: handleChange,
                onKeyDown: (event_1)=>handleKeyDown(event_1),
                isDisabled: isUploadingImage || isDisabled,
                elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    xcss: $cf7a0cd5aef48e09$var$iconContainerStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: "",
                    color: "currentColor"
                })),
                placeholder: formatMessage((0, $6b20cf9bddcc6c7c$export$defe85febe8b728c).refinedUnsplashSearchPlaceholderText)
            })
    });
};
module.exports["UnsplashSearchBar"] = $cf7a0cd5aef48e09$export$a7e261e3ec8ef2a0;

});

parcelRegister("iBGZJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cfM7x = parcelRequire("cfM7x");


var $iaYF8 = parcelRequire("iaYF8");


var $3vLBh = parcelRequire("3vLBh");


var $619Qo = parcelRequire("619Qo");




const $94992f5ffe8267c9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unsplashApiNoNetworkErrorMessage: {
        id: "company-hub.company-hub-common.unsplash.search.error.no-network-message",
        defaultMessage: "We\u2019ve lost the connection. Try again."
    },
    unsplashApiBadStatusErrorMessage: {
        id: "company-hub.company-hub-common.unsplash.error.bad-request-message",
        defaultMessage: "We can\u2019t get a response from Unsplash. Refresh and try again."
    },
    unsplashApiRateLimitedErrorMessage: {
        id: "company-hub.company-hub-common.unsplash.error.rate-limited-message",
        defaultMessage: "We can\u2019t get a response from Unsplash. Wait a moment, then try again."
    }
});


const $72fb3ac4368cb178$var$isBadStatusError = (error)=>error.message.includes('400');
const $72fb3ac4368cb178$var$isRateLimitedError = (error)=>error.message.includes('429');
var $72fb3ac4368cb178$export$d14ec7f08a14d421 = /*#__PURE__*/ function(UnsplashFetchError) {
    UnsplashFetchError["NO_NETWORK_ERROR"] = "network_error";
    UnsplashFetchError["RATE_LIMITED_ERROR"] = "rate_limited_error";
    UnsplashFetchError["BAD_STATUS_ERROR"] = "bad_status_error";
    return UnsplashFetchError;
}({});
const $72fb3ac4368cb178$var$i18nErrorText = {
    ["network_error"]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $94992f5ffe8267c9$export$defe85febe8b728c).unsplashApiNoNetworkErrorMessage),
    ["bad_status_error"]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $94992f5ffe8267c9$export$defe85febe8b728c).unsplashApiBadStatusErrorMessage),
    ["rate_limited_error"]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $94992f5ffe8267c9$export$defe85febe8b728c).unsplashApiRateLimitedErrorMessage)
};
const $72fb3ac4368cb178$export$d0105baa5ed279b8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isPageTitleComponent, selectedImageUrl, initialUnsplashResults)=>{
    const $ = (0, $bDgLe.c)(13);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [defaultUnsplashResults, setDefaultUnsplashResults] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[1] = t1;
    } else t1 = $[1];
    const [unSplashSearchResults, setUnsplashSearchResults] = (0, $cozmU.useState)(t1);
    const [fetchError, setError] = (0, $cozmU.useState)();
    const contentTopperDefaultImageUrl = (0, $619Qo.isUnsplashImage)(selectedImageUrl) ? selectedImageUrl : "";
    const selectedDefaultImageUrl = !isPageTitleComponent ? selectedImageUrl : contentTopperDefaultImageUrl;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (error)=>{
            if ($72fb3ac4368cb178$var$isRateLimitedError(error)) setError("rate_limited_error");
            else if ($72fb3ac4368cb178$var$isBadStatusError(error)) setError("bad_status_error");
            else setError("network_error");
            setUnsplashSearchResults(undefined);
        };
        $[2] = t2;
    } else t2 = $[2];
    const handleError = t2;
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    let t3;
    let t4;
    if ($[3] !== initialUnsplashResults || $[4] !== isPageTitleComponent || $[5] !== submitError) {
        t3 = ()=>{
            if (!initialUnsplashResults) {
                const defaultUnsplashQueryWord = isPageTitleComponent ? (0, $iaYF8.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD) : (0, $iaYF8.DEFAULT_UNSPLASH_QUERY_WORD);
                (0, $3vLBh.getUnsplashPhotos)(defaultUnsplashQueryWord, 1, submitError, isPageTitleComponent).then((result)=>{
                    setUnsplashSearchResults(result);
                    setDefaultUnsplashResults(result);
                }).catch((responseError)=>{
                    handleError(responseError);
                });
            } else {
                setUnsplashSearchResults(initialUnsplashResults);
                setDefaultUnsplashResults(initialUnsplashResults);
            }
        };
        t4 = [
            initialUnsplashResults,
            isPageTitleComponent,
            handleError,
            submitError
        ];
        $[3] = initialUnsplashResults;
        $[4] = isPageTitleComponent;
        $[5] = submitError;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const t5 = fetchError ? $72fb3ac4368cb178$var$i18nErrorText[fetchError] : undefined;
    let t6;
    if ($[8] !== defaultUnsplashResults || $[9] !== selectedDefaultImageUrl || $[10] !== t5 || $[11] !== unSplashSearchResults) {
        t6 = {
            selectedDefaultImageUrl: selectedDefaultImageUrl,
            defaultUnsplashResults: defaultUnsplashResults,
            unSplashSearchResults: unSplashSearchResults,
            errorMessage: t5,
            handleError: handleError,
            setUnsplashSearchResults: setUnsplashSearchResults,
            setDefaultUnsplashResults: setDefaultUnsplashResults,
            setError: setError
        };
        $[8] = defaultUnsplashResults;
        $[9] = selectedDefaultImageUrl;
        $[10] = t5;
        $[11] = unSplashSearchResults;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : (isPageTitleComponent, selectedImageUrl, initialUnsplashResults)=>{
    const [defaultUnsplashResults, setDefaultUnsplashResults] = (0, $cozmU.useState)([]);
    const [unSplashSearchResults, setUnsplashSearchResults] = (0, $cozmU.useState)([]);
    const [fetchError, setError] = (0, $cozmU.useState)();
    const contentTopperDefaultImageUrl = (0, $619Qo.isUnsplashImage)(selectedImageUrl) ? selectedImageUrl : '';
    const selectedDefaultImageUrl = !isPageTitleComponent ? selectedImageUrl : contentTopperDefaultImageUrl;
    const handleError = (0, $cozmU.useCallback)((error)=>{
        if ($72fb3ac4368cb178$var$isRateLimitedError(error)) setError("rate_limited_error");
        else if ($72fb3ac4368cb178$var$isBadStatusError(error)) setError("bad_status_error");
        else setError("network_error");
        setUnsplashSearchResults(undefined);
    }, [
        setError,
        setUnsplashSearchResults
    ]);
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    (0, $cozmU.useEffect)(()=>{
        if (!initialUnsplashResults) {
            const defaultUnsplashQueryWord = isPageTitleComponent ? (0, $iaYF8.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD) : (0, $iaYF8.DEFAULT_UNSPLASH_QUERY_WORD);
            (0, $3vLBh.getUnsplashPhotos)(defaultUnsplashQueryWord, 1, submitError, isPageTitleComponent).then((result)=>{
                setUnsplashSearchResults(result);
                setDefaultUnsplashResults(result);
            }).catch((responseError)=>{
                handleError(responseError);
            });
        } else {
            setUnsplashSearchResults(initialUnsplashResults);
            setDefaultUnsplashResults(initialUnsplashResults);
        }
    }, [
        initialUnsplashResults,
        isPageTitleComponent,
        handleError,
        submitError
    ]);
    return {
        selectedDefaultImageUrl: selectedDefaultImageUrl,
        defaultUnsplashResults: defaultUnsplashResults,
        unSplashSearchResults: unSplashSearchResults,
        errorMessage: fetchError ? $72fb3ac4368cb178$var$i18nErrorText[fetchError] : undefined,
        handleError: handleError,
        setUnsplashSearchResults: setUnsplashSearchResults,
        setDefaultUnsplashResults: setDefaultUnsplashResults,
        setError: setError
    };
};
module.exports["useUnsplash"] = $72fb3ac4368cb178$export$d0105baa5ed279b8;

});

parcelRegister("eLJUB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $1sCHt = parcelRequire("1sCHt");


var $kB5K2 = parcelRequire("kB5K2");


var $I7hWB = parcelRequire("I7hWB");


var $bh4C9 = parcelRequire("bh4C9");


var $4o0zT = parcelRequire("4o0zT");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $9vJye = parcelRequire("9vJye");


var $5KFAG = parcelRequire("5KFAG");


var $hgxhy = parcelRequire("hgxhy");


var $eI3GM = parcelRequire("eI3GM");


var $3qXic = parcelRequire("3qXic");


var $k8b3h = parcelRequire("k8b3h");


var $iBGZJ = parcelRequire("iBGZJ");




const $3dafd8ff917704a4$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    uploadMediaLabel: {
        id: "company-hub.company-hub-common.unsplash.upload.label",
        defaultMessage: "Upload"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3018f41b1ada6fc0$var$UnsplashSearchFlexContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ])
    });
});
const $3018f41b1ada6fc0$var$UploadButtonWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1VtPS8UF4f _2rM4gtUF4f",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1VtPS8UF4f _2rM4gtUF4f",
            __cmplp.className
        ])
    });
});
const $3018f41b1ada6fc0$var$bottomSpacing = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
const $3018f41b1ada6fc0$var$removeBottomSpacing = (0, $buxP3.xcss)({
    marginBottom: 'space.0'
});
const $3018f41b1ada6fc0$export$7db48b229e0f0751 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(60);
    const { id: id, idPrefix: idPrefix, imageAltText: imageAltText, sectionLabel: sectionLabel, helperMessage: helperMessage, selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, handleImageSelection: handleImageSelection, openMediaBrowser: openMediaBrowser, dropdownPopupComponentRef: dropdownPopupComponentRef, placement: t1, contentId: contentId, confluencePageId: confluencePageId, analyticsSource: analyticsSource, analyticsActionSubject: analyticsActionSubject, analyticsActionSubjectId: analyticsActionSubjectId, isPageTitleComponent: t2, isUploadingImage: t3, isNoImageAllowed: isNoImageAllowed, enableBottomSpacing: t4 } = t0;
    const placement = t1 === undefined ? "bottom" : t1;
    const isPageTitleComponent = t2 === undefined ? false : t2;
    const isUploadingImage = t3 === undefined ? false : t3;
    const enableBottomSpacing = t4 === undefined ? true : t4;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const { selectedDefaultImageUrl: selectedDefaultImageUrl, setDefaultUnsplashResults: setDefaultUnsplashResults, defaultUnsplashResults: defaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError, errorMessage: errorMessage } = (0, $iBGZJ.useUnsplash)(isPageTitleComponent, selectedImageUrl, initialUnsplashResults);
    const unsplashSearchFieldId = id ? `${idPrefix}-search-unsplash-${id}` : `${idPrefix}-search-unsplash`;
    let t5;
    if ($[0] !== analyticsActionSubject || $[1] !== analyticsActionSubjectId || $[2] !== analyticsSource || $[3] !== createAnalyticsEvent || $[4] !== openMediaBrowser) {
        t5 = ()=>{
            openMediaBrowser && openMediaBrowser();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: analyticsActionSubject,
                    actionSubjectId: analyticsActionSubjectId,
                    source: analyticsSource
                }
            }).fire();
        };
        $[0] = analyticsActionSubject;
        $[1] = analyticsActionSubjectId;
        $[2] = analyticsSource;
        $[3] = createAnalyticsEvent;
        $[4] = openMediaBrowser;
        $[5] = t5;
    } else t5 = $[5];
    const handleUploadButtonClick = t5;
    let t6;
    if ($[6] !== sectionLabel || $[7] !== unsplashSearchFieldId) {
        t6 = (0, $4o0zT.isExperimentEnabled)("a11y-fixes-week4-may-2026") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            as: "h2"
        }, sectionLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: unsplashSearchFieldId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
            showUpdatedStyles: true
        }, sectionLabel));
        $[6] = sectionLabel;
        $[7] = unsplashSearchFieldId;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== helperMessage || $[10] !== isDisabled) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eI3GM.MediaContentHelperMessage), {
            helperMessage: helperMessage,
            isDisabled: isDisabled
        });
        $[9] = helperMessage;
        $[10] = isDisabled;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== analyticsSource || $[13] !== defaultUnsplashResults || $[14] !== dropdownPopupComponentRef || $[15] !== handleError || $[16] !== handleImageSelection || $[17] !== idPrefix || $[18] !== isUploadingImage || $[19] !== placement || $[20] !== setDefaultUnsplashResults || $[21] !== setError || $[22] !== setUnsplashSearchResults || $[23] !== unSplashSearchResults || $[24] !== unsplashSearchFieldId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k8b3h.UnsplashSearchBar), {
            unsplashSearchFieldId: unsplashSearchFieldId,
            elementIdPrefix: idPrefix,
            handleImageSelection: handleImageSelection,
            analyticsSource: analyticsSource,
            setDefaultUnsplashResults: setDefaultUnsplashResults,
            defaultUnsplashResults: defaultUnsplashResults,
            unSplashSearchResults: unSplashSearchResults,
            setUnsplashSearchResults: setUnsplashSearchResults,
            setError: setError,
            handleError: handleError,
            placement: placement,
            dropdownPopupComponentRef: dropdownPopupComponentRef,
            isUploadingImage: isUploadingImage
        });
        $[12] = analyticsSource;
        $[13] = defaultUnsplashResults;
        $[14] = dropdownPopupComponentRef;
        $[15] = handleError;
        $[16] = handleImageSelection;
        $[17] = idPrefix;
        $[18] = isUploadingImage;
        $[19] = placement;
        $[20] = setDefaultUnsplashResults;
        $[21] = setError;
        $[22] = setUnsplashSearchResults;
        $[23] = unSplashSearchResults;
        $[24] = unsplashSearchFieldId;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== handleUploadButtonClick || $[27] !== intl || $[28] !== isDisabled || $[29] !== isUploadingImage || $[30] !== openMediaBrowser) {
        t9 = !!openMediaBrowser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3018f41b1ada6fc0$var$UploadButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            onClick: handleUploadButtonClick,
            testId: "open-media-browser",
            isDisabled: isUploadingImage || isDisabled,
            icon: $3018f41b1ada6fc0$var$_temp,
            label: intl.formatMessage((0, $3dafd8ff917704a4$export$defe85febe8b728c).uploadMediaLabel)
        }));
        $[26] = handleUploadButtonClick;
        $[27] = intl;
        $[28] = isDisabled;
        $[29] = isUploadingImage;
        $[30] = openMediaBrowser;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== t8 || $[33] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, t8, t9);
        $[32] = t8;
        $[33] = t9;
        $[34] = t10;
    } else t10 = $[34];
    const t11 = enableBottomSpacing ? $3018f41b1ada6fc0$var$bottomSpacing : $3018f41b1ada6fc0$var$removeBottomSpacing;
    let t12;
    if ($[35] !== defaultUnsplashResults) {
        t12 = defaultUnsplashResults?.slice(0, 5);
        $[35] = defaultUnsplashResults;
        $[36] = t12;
    } else t12 = $[36];
    const t13 = isNoImageAllowed && !isPageTitleComponent;
    let t14;
    if ($[37] !== analyticsSource || $[38] !== confluencePageId || $[39] !== contentId || $[40] !== handleImageSelection || $[41] !== imageAltText || $[42] !== isUploadingImage || $[43] !== selectedDefaultImageUrl || $[44] !== t12 || $[45] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qXic.DefaultImagePicker), {
            contentId: contentId,
            confluencePageId: confluencePageId,
            initialUnsplashResults: t12,
            handleImageSelection: handleImageSelection,
            imageAltText: imageAltText,
            selectedImageUrl: selectedDefaultImageUrl,
            analyticsSource: analyticsSource,
            isUploadingImage: isUploadingImage,
            isNoImageAllowed: t13
        });
        $[37] = analyticsSource;
        $[38] = confluencePageId;
        $[39] = contentId;
        $[40] = handleImageSelection;
        $[41] = imageAltText;
        $[42] = isUploadingImage;
        $[43] = selectedDefaultImageUrl;
        $[44] = t12;
        $[45] = t13;
        $[46] = t14;
    } else t14 = $[46];
    let t15;
    if ($[47] !== t11 || $[48] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t11
        }, t14);
        $[47] = t11;
        $[48] = t14;
        $[49] = t15;
    } else t15 = $[49];
    let t16;
    if ($[50] !== errorMessage) {
        t16 = errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5KFAG.FormFieldErrorMessage), null, errorMessage);
        $[50] = errorMessage;
        $[51] = t16;
    } else t16 = $[51];
    let t17;
    if ($[52] !== t15 || $[53] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), null, t15, t16);
        $[52] = t15;
        $[53] = t16;
        $[54] = t17;
    } else t17 = $[54];
    let t18;
    if ($[55] !== t10 || $[56] !== t17 || $[57] !== t6 || $[58] !== t7) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3018f41b1ada6fc0$var$UnsplashSearchFlexContainer, null, t6, t7, t10, t17);
        $[55] = t10;
        $[56] = t17;
        $[57] = t6;
        $[58] = t7;
        $[59] = t18;
    } else t18 = $[59];
    return t18;
} : ({ id: id, idPrefix: idPrefix, imageAltText: imageAltText, sectionLabel: sectionLabel, helperMessage: helperMessage, selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, handleImageSelection: handleImageSelection, openMediaBrowser: openMediaBrowser, dropdownPopupComponentRef: dropdownPopupComponentRef, placement: placement = 'bottom', contentId: contentId, confluencePageId: confluencePageId, analyticsSource: analyticsSource, analyticsActionSubject: analyticsActionSubject, analyticsActionSubjectId: analyticsActionSubjectId, isPageTitleComponent: isPageTitleComponent = false, isUploadingImage: isUploadingImage = false, isNoImageAllowed: isNoImageAllowed, enableBottomSpacing: enableBottomSpacing = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const { selectedDefaultImageUrl: selectedDefaultImageUrl, setDefaultUnsplashResults: setDefaultUnsplashResults, defaultUnsplashResults: defaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError, errorMessage: errorMessage } = (0, $iBGZJ.useUnsplash)(isPageTitleComponent, selectedImageUrl, initialUnsplashResults);
    const unsplashSearchFieldId = id ? `${idPrefix}-search-unsplash-${id}` : `${idPrefix}-search-unsplash`;
    const handleUploadButtonClick = ()=>{
        openMediaBrowser && openMediaBrowser();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: analyticsActionSubject,
                actionSubjectId: analyticsActionSubjectId,
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3018f41b1ada6fc0$var$UnsplashSearchFlexContainer, null, (0, $4o0zT.isExperimentEnabled)('a11y-fixes-week4-may-2026') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h2"
    }, sectionLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: unsplashSearchFieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
        showUpdatedStyles: true
    }, sectionLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eI3GM.MediaContentHelperMessage), {
        helperMessage: helperMessage,
        isDisabled: isDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k8b3h.UnsplashSearchBar), {
        unsplashSearchFieldId: unsplashSearchFieldId,
        elementIdPrefix: idPrefix,
        handleImageSelection: handleImageSelection,
        analyticsSource: analyticsSource,
        setDefaultUnsplashResults: setDefaultUnsplashResults,
        defaultUnsplashResults: defaultUnsplashResults,
        unSplashSearchResults: unSplashSearchResults,
        setUnsplashSearchResults: setUnsplashSearchResults,
        setError: setError,
        handleError: handleError,
        placement: placement,
        dropdownPopupComponentRef: dropdownPopupComponentRef,
        isUploadingImage: isUploadingImage
    }), !!openMediaBrowser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3018f41b1ada6fc0$var$UploadButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        onClick: handleUploadButtonClick,
        testId: "open-media-browser",
        isDisabled: isUploadingImage || isDisabled,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        label: intl.formatMessage((0, $3dafd8ff917704a4$export$defe85febe8b728c).uploadMediaLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: enableBottomSpacing ? $3018f41b1ada6fc0$var$bottomSpacing : $3018f41b1ada6fc0$var$removeBottomSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qXic.DefaultImagePicker), {
        contentId: contentId,
        confluencePageId: confluencePageId,
        initialUnsplashResults: defaultUnsplashResults?.slice(0, 5),
        handleImageSelection: handleImageSelection,
        imageAltText: imageAltText,
        selectedImageUrl: selectedDefaultImageUrl,
        analyticsSource: analyticsSource,
        isUploadingImage: isUploadingImage,
        isNoImageAllowed: isNoImageAllowed && !isPageTitleComponent
    })), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5KFAG.FormFieldErrorMessage), null, errorMessage)));
};
function $3018f41b1ada6fc0$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
}
module.exports["UnsplashSearch"] = $3018f41b1ada6fc0$export$7db48b229e0f0751;

});


//# sourceMappingURL=cards-extension.def0cc12.js.map
